import script from "./MainVue.vue?vue&type=script&setup=true&lang=js"
export * from "./MainVue.vue?vue&type=script&setup=true&lang=js"

import "./MainVue.vue?vue&type=style&index=0&id=62485e90&lang=css"

const __exports__ = script;

export default __exports__